<template>
  <div>
    <div class="titleInfoBox">
      <el-button type="primary" plain @click="showAddJobNotice">新建榜单</el-button>
    </div>
    <div class="itemList">
      <div class="itemDiv" v-for="item in dataList" :key="item.id">
        <div class="leftDiv">
          <P>{{item.industry + '----' + item.topName}}</P>
          <p>创建时间：{{item.createTime}}</p>
          <p>序号：{{item.topSort}}</p>
        </div>
        <div class="rightDiv">
          <div>
            <el-popover
              placement="right"
              title="提示"
              width="200"
              trigger="click"
              v-model="item.visible"
            >
              <p>是否删除该条榜单</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="item.visible = false">取消</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="item.visible = false;deleteNotice(item)"
                >确定</el-button>
              </div>
              <el-button slot="reference">删除该榜单</el-button>
            </el-popover>
            <el-button slot="reference" @click="viewRank(item)">查看排行情况</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="block">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageNumber"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="pageTotal"
      ></el-pagination>
    </div>
    <el-dialog title="职位公告" :visible.sync="dialogVisible" width="30%">
      <div class="demo-input-suffix">
        <h2>新建榜单</h2>
        <div style="padding: 15px 0;">榜单名称:</div>
        <el-input placeholder="请输入榜单名称" type="text" v-model="topName" maxlength="40"></el-input>
        <div style="padding: 15px 0;">榜单序号:</div>
        <el-input placeholder="请输入榜单序号" type="number" v-model="topSort"></el-input>
        <div style="padding: 15px 0;">行业：</div>
        <el-select
          v-model="selectHy"
          placeholder="请选择行业"
        >
          <el-option
            v-for="item in hyArray"
            :key="item.code"
            :label="item.description"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="okNumber()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Config from "../config/index";
export default {
  name: "rankClassList",
  props: {},
  data() {
    return {
      hyArray: [],
      selectHy: {
        description: ""
      },
      topName: "",
      topSort: "",
      jobNotice: "",
      positionName: "",
      pageSize: 20,
      pageNumber: 1,
      pageTotal: 0,
      dataList: [],
      id: "",
      dialogVisible: false,
      setid: "",
      setItem: {},
      setPdfUrl: "",
      setnum: "",
      selectType: "待审核",
      selectTypeArray: {
        待审核: 1,
        已审核: 2,
        审核失败: 3
      },
      monthlyPay: 0,
      moneyReward: 0,
      entryDate: "",
      commissionMethod: false,
      homeAmount: 0,
      warrantyAmount: 0,
      jobInfo: {},
      tdrInfo: {},
      tdrInfoStatus: false,
      reasShBox: false,
      shsbInfoStatus: false,
      setShsbItem: {
        sbyyInfo: ""
      }
    };
  },
  watch: {},
  created: function() {
    this.id = this.$route.query.id;
  },
  methods: {
    showAddJobNotice: function() {
      this.dialogVisible = true;
    },

    deleteNotice: function(item) {
      let that = this;
      axios({
        method: "POST",
        url: Config.path + "/api/platform/top/delTop",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("token")
        },
        data: {
          id: item.id
        }
      })
        .then(function(response) {
          // eslint-disable-next-line
          console.log(response);
          if (response.data.success === "1") {
            that.pageNumber = 1;
            that.jobNotice = "";
            that.getJobNoticeList();
          } else if (response.data.success === "111111") {
            that.$router.push({
              path: "/login"
            });
          } else {
            that.$message({
              message: response.data.message,
              type: "warning"
            });
          }
        })
        .catch(function(error) {
          // eslint-disable-next-line
          console.log(error);
        });
    },

    handleCurrentChange: function(val) {
      this.pageNumber = val;
      this.getJobNoticeList();
    },
    okNumber: function() {
              if (this.topName === '' || this.topSort === '' || this.selectHy.description === '') {

          this.$message({
                    message: '信息不完整',
                    type: "warning"
                });
          return false
      }
      let that = this;
      axios({
        method: "POST",
        url: Config.path + "/api/platform/top/ckSort",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("token")
        },
        data: {
          topSort: this.topSort
        }
      })
        .then(function(response) {
          // eslint-disable-next-line
          console.log(response);
          if (response.data.success === "1") {
              if (response.data.content.length === 0) {
                that.saveTop()
              } else {
                  that.$message({
                    message: '编号重复',
                    type: "warning"
                });
              }
          } else if (response.data.success === "111111") {
            that.$router.push({
              path: "/login"
            });
          } else {
            that.$message({
              message: response.data.message,
              type: "warning"
            });
          }
        })
        .catch(function(error) {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    saveTop: function() {

      let that = this;
      if (this.topName === '' || this.topSort === '' || this.selectHy.description === '') {

          that.$message({
                    message: '信息不完整',
                    type: "warning"
                });
          return false
      }
      this.dialogVisible = false
      axios({
        method: "POST",
        url: Config.path + "/api/platform/top/createTop",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("token")
        },
        data: {
         topName: this.topName,
         topSort: this.topSort,
         industry: this.selectHy.description,
         industryCode: this.selectHy.code,
        }
      })
        .then(function(response) {
          // eslint-disable-next-line
          console.log(response);
          if (response.data.success === "1") {
            that.pageNumber = 1;
            that.dialogVisible = false;
            that.topName = "";
            that.topSort = "";
            that.selectHy = {
                description: ''
            }
            that.getJobNoticeList();
          } else if (response.data.success === "111111") {
            that.$router.push({
              path: "/login"
            });
          } else {
            that.$message({
              message: response.data.message,
              type: "warning"
            });
          }
        })
        .catch(function(error) {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    getJobNoticeList: function() {
      let that = this;
      axios({
        method: "POST",
        url: Config.path + "/api/platform/top/getTopList",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("token")
        },
        data: {
          pageSize: this.pageSize,
          pageNum: this.pageNumber
        }
      })
        .then(function(response) {
          // eslint-disable-next-line
          console.log(response);
          if (response.data.success === "1") {
            let demo = response.data.content.list;
            for (let i in demo) {
              demo[i].visible = false;
            }
            that.dataList = demo;
            that.pageTotal = response.data.content.total;
          } else if (response.data.success === "111111") {
            that.$router.push({
              path: "/login"
            });
          } else {
            that.$message({
              message: response.data.message,
              type: "warning"
            });
          }
        })
        .catch(function(error) {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    getHyList: function() {
      let that = this;
      let data = {
        type: "jobType"
      };
      axios({
        method: "GET",
        url: Config.path + "/api/common/dict/getlist",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.getItem("token")
        },
        params: data
      })
        .then(function(response) {
          // eslint-disable-next-line
          console.log(response);
          if (response.data.success === "1") {
            that.hyArray = response.data.content;
          } else if (response.data.success === "111111") {
            that.$router.push({
              path: "/login"
            });
          } else {
            that.$message({
              message: response.data.message,
              type: "warning"
            });
          }
        })
        .catch(function(error) {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    viewRank: function (item) {
                    this.$router.push({
                path: '/viewRank',
                query: {
                    id: item.id
                }
            })
    }
  },
  mounted: function() {
    this.getJobNoticeList();
    this.getHyList();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.itemList {
  margin-top: 20px;
}

.itemList .itemDiv {
  background-color: #ffffff;
  width: 80%;
  margin: 0 auto 15px auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 25px;
  border-radius: 8px;
  min-height: 150px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.itemList .itemDiv .leftDiv {
  width: 70%;
}

.itemList .itemDiv .leftDiv p {
  font-size: 18px;
  color: #757373;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.itemList .itemDiv .leftDiv div {
  padding: 30px 0;
}

.itemList .itemDiv .rightDiv {
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

.itemList .itemDiv .rightDiv p {
  font-size: 32px;
  color: #1aad19;
  text-align: center;
}

.itemList .itemDiv .rightDiv .active {
  color: red;
}

.itemList .itemDiv .rightDiv div {
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.block {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
}

.demo-input-suffix > p {
  padding: 10px 0;
}

.reasShBox {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  position: fixed;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.reasShBox > div {
  width: 50vw;
  height: 100vh;
  overflow: hidden;
  overflow-y: scroll;
}

.reasShBox > div > iframe {
  width: 100%;
  height: 100%;
}

.reasShBox > div:nth-child(1) {
  background-color: #ffffff;
  padding: 30px;
  box-sizing: border-box;
}

.reasShBox > div .title {
  padding: 10px 0;
  width: max-content;
  background-color: #cecece;
}

.reasShBox > div .cont {
  padding: 10px;
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: break-all;
}

.reasShBox .buttonBox {
  width: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.titleInfoBox {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 30px 200px;
  box-sizing: border-box;
}

.titleInfoBox .text {
  padding-right: 20px;
}
</style>
